import { Link, Outlet, useMatchRoute } from '@tanstack/react-router'
import { PageHeader } from '@/components/ui/page-header'
import { useAuth } from '@/hooks/use-auth'
import { cn } from '@/lib/utils'

interface Tab {
  to: string
  label: string
  exact?: boolean
}

export function SettingsLayout() {
  const { user } = useAuth()
  const matchRoute = useMatchRoute()

  const isAdmin = user?.role === 'tenant_admin' || user?.role === 'super_admin'
  // Correo: Admin y Gestor (el remitente dentro solo lo edita super_admin).
  const canWrite = !!user && user.role !== 'tenant_viewer'

  const tabs: Tab[] = [
    { to: '/settings', label: 'General', exact: true },
    { to: '/settings/team', label: 'Equipo' },
    ...(isAdmin
      ? [
          { to: '/settings/licenses', label: 'Catalogo de licencias' },
          { to: '/settings/rules', label: 'Reglas de recomendaciones' },
        ]
      : []),
    ...(canWrite ? [{ to: '/settings/email', label: 'Correo' }] : []),
  ]

  return (
    <div className="space-y-6">
      <PageHeader title="Configuracion" description="Gestiona tu organizacion y equipo" />

      <nav
        className="flex flex-wrap gap-1 border-b"
        style={{ borderColor: 'var(--color-border)' }}
      >
        {tabs.map((tab) => {
          const active = tab.exact
            ? matchRoute({ to: tab.to, fuzzy: false })
            : matchRoute({ to: tab.to, fuzzy: true })
          return (
            <Link
              key={tab.to}
              to={tab.to}
              className={cn(
                '-mb-px border-b-2 px-4 py-2.5 text-sm font-medium transition-colors',
              )}
              style={{
                borderBottomColor: active ? 'var(--color-brand-secondary)' : 'transparent',
                color: active ? 'var(--color-brand-secondary)' : 'var(--color-text-secondary)',
              }}
            >
              {tab.label}
            </Link>
          )
        })}
      </nav>

      <Outlet />
    </div>
  )
}
